import React, { useEffect } from "react";
import { SvgIcon } from "@montana/shared/svg-icon";
import { useRouter } from "@montana/containers/router";

export interface IHeaderSearchProps {
    onClose: () => void;
    onOpen: () => void;
    active: boolean;
}


export const HeaderSearch: React.FC<IHeaderSearchProps> = React.memo(({ onClose, onOpen, active }: IHeaderSearchProps): JSX.Element => {
    const { location } = useRouter();

    useEffect(() => {
        onClose();
    }, [location]);

    return (
        <button className="search-toggle" onClick={active ? onClose : onOpen}>
            {active && <SvgIcon className="search-toggle__svg" iconName="search_active" />}
            {!active && <SvgIcon className="search-toggle__svg" iconName="search" />}
        </button>
    );
});
